require('./scroll-slider');
require('./swipe-slider');
require('./rslider');
require('./how-to-connect-slider');
require('./history-slider');